import { memo } from 'react';
import { Box, Header, SpaceBetween } from '@amzn/awsui-components-core';
import ToggleButton from '@amzn/awsui-components-core/toggle-button';

import { ContentFeedback } from '../v2-common/ContentFeedback';
import { CustomerInfluenceView } from './CustomerInfluenceView';
import { DownloadPdfView } from './DownloadPdfView';
import { MetaDivider } from '../v2-common/MetaDivider';
import { useContentViewTitleViewModel } from './ContentViewTitleViewModel';
import styles from './ContentViewTitleView.module.scss';

/**
 * Read-only title header: long title above a single metadata row of authors
 * byline, last-modified date, thumbs up/down, "record reuse", and PDF download.
 */
export const ContentViewTitleView = memo(function ContentViewTitleView() {
  const vm = useContentViewTitleViewModel();

  if (!vm) return null;

  // The metadata row renders as a sibling below the Header rather than in its
  // `description` prop: Cloudscape renders `description` inside a <p>, and this
  // row contains <div>/<button> content (SpaceBetween, feedback, PDF), which is
  // invalid DOM nesting inside a paragraph.
  return (
    <SpaceBetween size={'m'}>
      <div className={styles.titleRow}>
        <div className={styles.titleContent}>
          <SpaceBetween size="xxs">
            <Header variant="h1">{vm.title}</Header>
          </SpaceBetween>
        </div>
        {vm.isCommentToggleVisible && (
          <div>
            <ToggleButton
              iconName="contact"
              pressedIconName="contact"
              pressed={vm.isCommentingPressed}
              onChange={({ detail }) => vm.toggleCommenting(detail.pressed)}
            >
              Comment
            </ToggleButton>
          </div>
        )}
      </div>
      <div className={styles.metaRow}>
        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
          <Box variant="span" color="text-body-secondary">
            By {vm.authorsByline}
          </Box>
          {vm.lastModified?.isValid && [
            <MetaDivider key="divider" />,
            <Box key="date" variant="span" color="text-body-secondary">
              Last modified on {vm.lastModified.toFormat('MMM d, yyyy')}
            </Box>,
          ]}
          <ContentFeedback />
          <CustomerInfluenceView />
          <DownloadPdfView />
        </SpaceBetween>
      </div>
    </SpaceBetween>
  );
});
